'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPreviousMessageClientTs = undefined;

var _reselect = require('reselect');

var _getCurrentConversation = require('../conversationSelectors/getCurrentConversation');

var _currentThreadHistory = require('../../thread-histories/selectors/currentThreadHistory');

var _getMessages = require('conversations-schema/thread-history/operators/getMessages');

var _commonMessageFormatGetters = require('conversations-schema/common-message-format/operators/commonMessageFormatGetters');

var CommonMessageFormatGetters = _interopRequireWildcard(_commonMessageFormatGetters);

var _messageTypeComparators = require('conversations-schema/pubnub-message/operators/messageTypeComparators');

var _getSenderId = require('./getSenderId');

var _getSenderType = require('./getSenderType');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var getPreviousMessageClientTs = exports.getPreviousMessageClientTs = (0, _reselect.createSelector)([_getCurrentConversation.getCurrentConversation, _currentThreadHistory.currentThreadHistory, _getSenderId.getSenderId, _getSenderType.getSenderType], function (conversation, threadHistory, senderId, senderType) {
  var lastMessageFromSender = (0, _getMessages.getMessages)(threadHistory).filter(_messageTypeComparators.isConversationalMessage).findLast(function (message) {
    return CommonMessageFormatGetters.getSenderId(message) === senderId && CommonMessageFormatGetters.getSenderType(message) === senderType;
  });

  return CommonMessageFormatGetters.getClientTs(lastMessageFromSender) || null;
});


//////////////////
// WEBPACK FOOTER
// ./js/selectors/pubNubMessageSelectors/getPreviousMessageClientTs.js
// module id = 234
// module chunks = 2 3